<template>
  <section>
    <header>
      <slot name="headings" :headings="headings">
        <div
          v-for="heading in headings"
          :key="heading"
          class="bm-col bm-heading text-center"
        >
          {{ heading }}
        </div>
      </slot>
    </header>
    <div v-for="(item, index) in items" :key="index">
      <div class="bm-col v-list-item__action">
        <slot name="leftcol" :item="item" :index="index">{{
          getPropertyFromItem(item, itemText)
        }}</slot>
      </div>
      <div class="bm-col v-list-item__action">
        <slot :item="item" :index="index" />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { VuetifyPropertyArg } from "@/components/utils/vuetifyHelpers";
import { getPropertyFromItem } from "@/components/utils/vuetifyHelpers";

/**
 * Simple control that displays a list of controls (slot content) with a title next to each one.
 */
export default defineComponent({
  name: "BmControlList",
  props: {
    headings: {
      type: Array as PropType<string[]>,
      default: () => [],
      required: true,
    },
    items: {
      type: Array as PropType<readonly any[]>,
      default: () => [],
      required: true,
    },
    itemText: {
      type: [String, Array, Function] as PropType<VuetifyPropertyArg>,
      default: "value",
      required: true,
    },
  },
  setup() {
    return {
      getPropertyFromItem,
    };
  },
});
</script>

<style scoped lang="sass">
.bm-heading
  padding-top: 20px!important

section
  display: table
  width: 100%

header > *
  padding-bottom: 30px!important

section > *
  display: table-row

section .bm-col
  display: table-cell
  padding: 5px
</style>
